/* eslint-disable max-len */
import React from 'react'
import { RouteObject } from 'react-router-dom'
import { AdminRightsView } from '../../../views/society/Management/AdminRightsView'
import { SocietySettingsView } from '../../../views/society/Management/SocietySettingsView'
import { InvoiceView } from '../../../views/society/Management/InvoiceView'
import { RegisterView } from '../../../views/society/Management/RegisterView'
import { SocietyWebsiteView } from '../../../views/society/Management/SocietyWebsiteView'
import { SocietyBlockedUsersView } from '../../../views/society/Management/SocietyBlockedUsersView'
import { GettingStartedView } from '../../../views/society/GettingStartedView'
import { GetToKnowView } from '../../../views/society/GetToKnowView'
import { GetToKnowCompletedView } from '../../../views/society/GetToKnowCompletedView'
import { GettingStartedCompletedView } from '../../../views/society/GettingStartedCompletedView'
import { BinderPickerView } from '../../../views/society/Management/BinderPickerView'
import { BinderView } from '../../../views/society/Management/ManagementBinderView'

const useSocietyAdminRoutes = (): RouteObject[] => {
  return [
    {
      path: 'billing/*',
      element: <InvoiceView />,
    },
    {
      path: 'register/*',
      element: <RegisterView />,
    },
    {
      path: 'binder',
      element: <BinderPickerView />,
    },
    {
      path: 'binder/:unitId/:folderId',
      element: <BinderView />,
    },
    {
      path: 'binder/:unitId',
      element: <BinderView />,
    },
    {
      path: 'admin-rights',
      element: <AdminRightsView />,
    },
    {
      path: 'website',
      element: <SocietyWebsiteView />,
    },
    {
      path: 'blocked-users',
      element: <SocietyBlockedUsersView />,
    },
    {
      path: 'getting-started',
      element: <GettingStartedView />,
    },
    {
      path: 'getting-started/completed',
      element: <GettingStartedCompletedView />,
    },
    {
      path: 'get-to-know',
      element: <GetToKnowView />,
    },
    {
      path: 'get-to-know/completed',
      element: <GetToKnowCompletedView />,
    },
    {
      path: 'settings',
      element: <SocietySettingsView />,
    },
  ]
}

useSocietyAdminRoutes.displayName = 'useSocietyAdminRoutes'
export { useSocietyAdminRoutes }
